import { render, staticRenderFns } from "./project-form.component.vue?vue&type=template&id=d781ac26"
import script from "./project-form.component.vue?vue&type=script&lang=js"
export * from "./project-form.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports